import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

const Searchbar = ({ label, onSearchFunction }) => {
   const [value, setValue] = useState("");

   useEffect(() => {
      const identifier = setTimeout(() => onSearchFunction(value), 500);

      return () => {
         clearTimeout(identifier);
      };
   }, [value]);

   const valueOnchange = (event) => {
      setValue(event.target.value);
   };

   return (
      <TextField
         label={label}
         value={value}
         onChange={valueOnchange}
         variant="standard"
         style={{
            width: "250px",
         }}
      />
   );
};

Searchbar.propTypes = {
   label: PropTypes.string,
   onSearchFunction: PropTypes.func,
};

export default Searchbar;
